import { NumberInputSchema } from '@ca/common'

// This would break for weird step values like 0.4 or 0.66
const possibleDecimalEndings = (step: 0.01 | 0.1 | 0.25 | 0.5 | 1) => {
  if (step >= 1) {
    return ['.00']
  }
  const options = 1 / step
  return Array(options)
    .fill(0)
    .map((_, i) => {
      const value = i * step
      return value.toFixed(2).split('.')[1]
    })
}

/**
 * Partial validation for number inputs
 * ie 1.7 matches 0.25 step
 */
export const getPartialValidate =
  (schema?: NumberInputSchema) => (v: string) => {
    if (v === '' || v === '-') {
      return true
    }
    const normalized = v.replace(',', '.')
    const [, decimals] = normalized.split('.')
    if (decimals && decimals.length > 2) {
      return false
    }
    const num = Number(normalized)
    if (!Number.isFinite(num)) {
      return false
    }
    if (!schema) {
      return true
    }
    // TODO: handle step > 1
    if (schema?.step == null) {
      return true
    }

    // TEMP: allow partial validation while inputing for pd (because schema.min > single digit)
    if (schema.allowPartial) {
      return true
    }

    if (schema.step > 1) {
      if (num % schema.step !== 0) {
        return false
      }
    }

    if (decimals?.length && schema?.step) {
      const endings = possibleDecimalEndings(schema.step)
      const partialStepMatch = endings.some((ed) => ed.includes(decimals))
      const matches = num % schema.step === 0 || partialStepMatch
      if (!matches) {
        return false
      }
    }
    if (schema?.min != null && num < schema.min) {
      return false
    }
    if (schema?.max != null && num > schema.max) {
      return false
    }

    return true
  }
